var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFoundSmImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 73,
    viewBox: "0 0 120 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.5723,
    y: 1,
    width: 55.2857,
    height: 54,
    rx: 6,
    fill: "#E4EFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5723 25H65.6014",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5723 13H41.5723C36.6017 13 32.5723 17.0294 32.5723 22V52C32.5723 56.9706 36.6017 61 41.5723 61H71.5723C76.5428 61 80.5723 56.9706 80.5723 52V22C80.5723 17.0294 76.5428 13 71.5723 13Z",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5723 46.0001L44.5723 34.0001C45.9404 32.6836 47.4924 31.9905 49.0723 31.9905C50.6521 31.9905 52.2041 32.6836 53.5723 34.0001L68.5723 49.0001",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5723 43.0001L65.5723 40.0001C66.9404 38.6836 68.4924 37.9905 70.0723 37.9905C71.6521 37.9905 73.2041 38.6836 74.5723 40.0001L80.5723 46.0001",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.4285H10.2857",
    stroke: "#A2B4B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.285 1H119.571",
    stroke: "#A2B4B9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFoundSmImg);
export default __webpack_public_path__ + "static/media/NoFoundSMImg.164e7aac3476f84a164d8227e2d5ccec.svg";
export { ForwardRef as ReactComponent };